export default {
    GET_LABOS: (state) => state.labos
};